module.exports = __webpack_public_path__ + "img/badge-silver.bb61c9d7.svg";